(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tpl-cart-design"] && !Shopify.designMode) return;
  try {
    (() => {
  document.addEventListener('theme:cart:refresh', async () => {
    if (!document.querySelector('.tpl-cart cart-element')) return;
    await customElements.whenDefined('cart-element');
    document.querySelector('.tpl-cart cart-element')?.getCart?.();
  });
  const prepareGift = async () => {
    if (location.hash !== '#prepare-gift') return;
    await customElements.whenDefined('collapsible-elements');
    const trigger = document.querySelector('.tpl-cart [aria-controls="gift-notes"]');
    if (!trigger) return;
    if (trigger.getAttribute('aria-expanded') !== 'true') trigger.click();
    requestAnimationFrame(() => {
      trigger.scrollIntoView({block:'center',behavior:'instant'});
      trigger.focus({preventScroll:true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',prepareGift); else prepareGift();
  window.addEventListener('hashchange',prepareGift);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpl-club-principles"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => document.querySelectorAll('[data-mfc-manifesto]:not([data-mfc-ready])').forEach(root => {
    root.dataset.mfcReady = 'true';
    const links = [...root.querySelectorAll('[data-mfc-principle]')];
    const panels = [...root.querySelectorAll('[data-mfc-panel]')];
    const holder = root.querySelector('[data-mfc-panels]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let active = '', heightAnimation, contentAnimation;
    const select = (key, animate = true) => {
      heightAnimation?.cancel();
      contentAnimation?.cancel();
      const previousHeight = holder.getBoundingClientRect().height;
      active = key;
      panels.forEach(panel => { panel.hidden = panel.dataset.mfcPanel !== key; });
      links.forEach(link => link.setAttribute('aria-expanded', String(link.dataset.mfcPrinciple === key)));
      const current = panels.find(panel => !panel.hidden);
      if (animate && !reduced.matches && holder.animate) {
        heightAnimation = holder.animate([{height:previousHeight+'px'},{height:holder.getBoundingClientRect().height+'px'}],{duration:180,easing:'ease-out'});
        if (current) contentAnimation = current.animate([{opacity:0,transform:'translateY(3px)'},{opacity:1,transform:'translateY(0)'}],{duration:180,easing:'ease-out'});
      }
    };
    links.forEach(link => {
      link.setAttribute('aria-controls', link.hash.slice(1));
      link.setAttribute('role', 'button');
      link.addEventListener('click', event => {
        event.preventDefault();
        select(active === link.dataset.mfcPrinciple ? '' : link.dataset.mfcPrinciple);
      });
      link.addEventListener('keydown', event => {
        if (event.key === ' ') { event.preventDefault(); link.click(); }
        if (event.key === 'Escape') select('');
      });
    });
    root.classList.add('is-enhanced');
    const linkedPanel = panels.find(panel => '#'+panel.id === location.hash);
    select(linkedPanel?.dataset.mfcPanel || '', false);
    root.querySelector('[data-mfc-shop]').addEventListener('click', event => {
      const target = document.getElementById(event.currentTarget.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      target.focus({preventScroll:true});
      target.scrollIntoView({behavior:reduced.matches?'auto':'smooth',block:'start'});
    });
    const section = root.closest('[data-section-type="tpl-made-for-club"]');
    section?.querySelector('[data-mfc-back]')?.addEventListener('click', event => {
      event.preventDefault();
      root.querySelector('[data-mfc-shop]').focus({preventScroll:true});
      select('', false);
      root.scrollIntoView({behavior:reduced.matches?'auto':'smooth',block:'start'});
    });
    window.addEventListener('hashchange', () => {
      const match = panels.find(panel => '#'+panel.id === location.hash);
      if (root.isConnected && match) select(match.dataset.mfcPanel, false);
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpl-commerce-events"] && !Shopify.designMode) return;
  try {
    (() => {
  if(window.properCommerceEventsReady)return;window.properCommerceEventsReady=true;
  const allowed=new Set(['filter_use','model_toggle','quick_add_open']);
  document.addEventListener('proper:commerce',event=>{
    const data=event.detail||{};if(!allowed.has(data.event))return;
    const shop=window.Shopify;
    if(shop?.customerPrivacy?.analyticsProcessingAllowed?.()!==true||typeof shop?.analytics?.publish!=='function')return;
    const payload={};if(data.view==='model'||data.view==='product')payload.view=data.view;
    try{Promise.resolve(shop.analytics.publish('proper:'+data.event,payload)).catch(()=>{});}catch{}
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpl-cookie-banner"] && !Shopify.designMode) return;
  try {
    (() => {
  const banner = document.getElementById('TplCookieBanner');
  const dialog = document.getElementById('TplCookiePreferences');
  if (!banner || !dialog) return;
  const form = dialog.querySelector('form');
  const keys = ['preferences', 'analytics', 'marketing'];
  const controls = [...document.querySelectorAll('[data-cookie-choice],[data-cookie-save]')];
  const privacyPage = document.querySelector('[data-tpl-privacy-choices]');
  const optOutButton = privacyPage?.querySelector('[data-tpl-data-opt-out]');
  const optOutStatus = privacyPage?.querySelector('[data-tpl-opt-out-status]');
  let optOutBusy = false;
  let api;
  let loading;
  let busy = false;
  let opener;
  const message = text => document.querySelectorAll('[data-cookie-status]').forEach(node => { node.textContent = text; });
  const enable = ready => controls.forEach(button => { button.disabled = !ready; });
  const read = () => api.currentVisitorConsent();
  const showOptOutState = () => {
    if (!privacyPage || !api || optOutBusy) return;
    const optedOut = read().sale_of_data === 'no';
    optOutButton.disabled = optedOut;
    optOutStatus.textContent = optedOut ? privacyPage.dataset.saved : '';
  };
  const saveOptOut = async () => {
    if (!privacyPage || optOutBusy) return;
    optOutBusy = true;
    optOutButton.disabled = true;
    optOutStatus.textContent = privacyPage.dataset.saving;
    try {
      await initialize();
      await new Promise((resolve, reject) => {
        const timer = setTimeout(() => reject(new Error('Privacy choice timed out')), 12000);
        api.setTrackingConsent({sale_of_data:false}, () => {
          clearTimeout(timer);
          if (read().sale_of_data === 'no') resolve();
          else reject(new Error('Privacy choice was not saved'));
        });
      });
      optOutStatus.textContent = privacyPage.dataset.saved;
    } catch (_) {
      optOutStatus.textContent = privacyPage.dataset.error;
      optOutButton.disabled = false;
    } finally {
      optOutBusy = false;
    }
  };
  optOutButton?.addEventListener('click', saveOptOut);
  const initialize = () => {
    if (api) return Promise.resolve(api);
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      let attempts = 0;
      const load = () => {
        if (window.Shopify?.customerPrivacy) return resolve(window.Shopify.customerPrivacy);
        if (window.Shopify?.loadFeatures) {
          window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}], error => {
            if (error || !window.Shopify.customerPrivacy) reject(error || new Error('Privacy API unavailable'));
            else resolve(window.Shopify.customerPrivacy);
          });
        } else if (++attempts < 25) window.setTimeout(load, 200);
        else reject(new Error('Privacy API unavailable'));
      };
      load();
    }).then(value => {
      api = value;
      banner.dataset.cookieReady = 'true';
      enable(true);
      message('');
      banner.querySelector('[data-cookie-retry]').hidden = true;
      return api;
    }).catch(error => {
      loading = null;
      enable(false);
      message(banner.dataset.error);
      banner.querySelector('[data-cookie-retry]').hidden = false;
      throw error;
    });
    return loading;
  };
  const sync = () => {
    const consent = read();
    keys.forEach(key => { form.elements[key].checked = consent[key] === 'yes'; });
  };
  const autoShow = () => {
    const consent = read();
    const undecided = keys.some(key => consent[key] !== 'yes' && consent[key] !== 'no');
    if (undecided && (banner.dataset.homepage === 'true' || api.shouldShowBanner())) banner.hidden = false;
  };
  const close = () => {
    if (dialog.open) dialog.close();
    if (opener?.isConnected && !opener.closest('[hidden]')) opener.focus({preventScroll:true});
  };
  const save = async values => {
    if (busy) return;
    busy = true;
    message('');
    try {
      await initialize();
      enable(false);
      await new Promise((resolve, reject) => {
        const timeout = window.setTimeout(() => reject(new Error('Consent request timed out')), 12000);
        api.setTrackingConsent(values, () => {
          window.clearTimeout(timeout);
          const consent = read();
          if (keys.every(key => consent[key] === (values[key] ? 'yes' : 'no'))) resolve();
          else reject(new Error('Consent was not saved'));
        });
      });
      banner.hidden = true;
      close();
    } catch (_) {
      message(banner.dataset.error);
    } finally {
      busy = false;
      enable(!!api);
    }
  };
  document.addEventListener('click', async event => {
    const settings = event.target.closest('[data-tpl-cookie-settings]');
    if (settings) {
      opener = settings;
      dialog.showModal();
      try { await initialize(); sync(); } catch (_) {}
      return;
    }
    const choice = event.target.closest('[data-cookie-choice]');
    if (choice) {
      const allow = choice.dataset.cookieChoice === 'all';
      save(Object.fromEntries(keys.map(key => [key,allow])));
    }
  });
  form.addEventListener('submit', event => {
    event.preventDefault();
    save(Object.fromEntries(keys.map(key => [key,form.elements[key].checked])));
  });
  dialog.querySelector('[data-cookie-close]').addEventListener('click', close);
  dialog.addEventListener('cancel', () => { if (opener?.isConnected) opener.focus({preventScroll:true}); });
  document.addEventListener('visitorConsentCollected', () => {
    if (!api) return;
    showOptOutState();
    const consent = read();
    if (keys.every(key => consent[key] === 'yes' || consent[key] === 'no')) banner.hidden = true;
  });
  const boot = () => initialize().then(() => { autoShow(); showOptOutState(); }).catch(() => {
    if (banner.dataset.homepage === 'true') banner.hidden = false;
    if (privacyPage) { optOutButton.disabled = false; optOutStatus.textContent = privacyPage.dataset.error; }
  });
  banner.querySelector('[data-cookie-retry]').addEventListener('click', boot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpl-derby-information"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => document.querySelectorAll('[data-derby-looks]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const track = root.querySelector('[data-look-track]');
    const cards = [...root.querySelectorAll('[data-look-card]')];
    const links = [...root.querySelectorAll('[data-look-open]')];
    if (!cards.length) return;
    const prev = root.querySelector('[data-look-prev]'), next = root.querySelector('[data-look-next]');
    const count = root.querySelector('[data-look-count]');
    const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    const step = () => cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
    const current = () => Math.min(cards.length-1,Math.max(0,Math.round(track.scrollLeft / Math.max(1,step()))));
    const edges = () => { prev.disabled = track.scrollLeft < 2; next.disabled = track.scrollLeft >= track.scrollWidth-track.clientWidth-2; count.textContent = `${String(current()+1).padStart(2,'0')} / ${String(cards.length).padStart(2,'0')}`; };
    const go = n => track.scrollTo({left:Math.max(0,Math.min(cards.length-1,n))*step(),behavior:motion()});
    prev.addEventListener('click',()=>go(current()-1));next.addEventListener('click',()=>go(current()+1));
    track.addEventListener('scroll',edges,{passive:true});
    track.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=current()+1;else if(e.key==='ArrowLeft')n=current()-1;else if(e.key==='Home')n=0;else if(e.key==='End')n=cards.length-1;else return;e.preventDefault();go(n);});
    let drag=null,suppress=false;
    track.addEventListener('dragstart',e=>e.preventDefault());
    track.addEventListener('pointerdown',e=>{if(e.pointerType==='mouse'&&e.button===0)drag={x:e.clientX,left:track.scrollLeft,id:e.pointerId,moved:false};});
    track.addEventListener('pointermove',e=>{if(!drag||e.pointerId!==drag.id)return;const dx=e.clientX-drag.x;if(!drag.moved&&Math.abs(dx)<6)return;drag.moved=true;suppress=true;track.setPointerCapture(e.pointerId);track.classList.add('is-dragging');e.preventDefault();track.scrollLeft=drag.left-dx;});
    const end=()=>{drag=null;track.classList.remove('is-dragging');setTimeout(()=>{suppress=false;},0);};
    track.addEventListener('pointerup',end);track.addEventListener('pointercancel',end);track.addEventListener('lostpointercapture',end);
    track.addEventListener('click',e=>{if(suppress){e.preventDefault();e.stopImmediatePropagation();}},true);
    const dialog=root.querySelector('[data-look-dialog]'), full=root.querySelector('[data-look-full]'), stage=root.querySelector('[data-look-stage]');
    const close=root.querySelector('[data-look-close]'), dp=root.querySelector('[data-look-dialog-prev]'), dn=root.querySelector('[data-look-dialog-next]');
    const less=root.querySelector('[data-look-less]'), more=root.querySelector('[data-look-more]'), reset=root.querySelector('[data-look-reset]');
    let selected=0,scale=1,opener;
    const zoom=value=>{scale=Math.max(1,Math.min(2,value));stage.classList.toggle('is-zoomed',scale>1);full.style.width=scale>1?`${full.naturalWidth*scale}px`:'';full.style.height=scale>1?`${full.naturalHeight*scale}px`:'';reset.textContent=`${Math.round(scale*100)}%`;less.disabled=scale===1;more.disabled=scale===2;};
    const show=n=>{selected=Math.max(0,Math.min(links.length-1,n));const link=links[selected];full.src=link.href;full.alt=link.querySelector('img').alt;root.querySelector('[data-look-dialog-title]').textContent=link.dataset.lookTitle;zoom(1);dp.disabled=selected===0;dn.disabled=selected===links.length-1;stage.scrollTo(0,0);};
    links.forEach((link,i)=>link.addEventListener('click',e=>{if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;e.preventDefault();opener=link;show(i);dialog.showModal();close.focus();}));
    close.addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>{zoom(1);opener?.focus({preventScroll:true});});
    dp.addEventListener('click',()=>show(selected-1));dn.addEventListener('click',()=>show(selected+1));less.addEventListener('click',()=>zoom(scale-.5));more.addEventListener('click',()=>zoom(scale+.5));reset.addEventListener('click',()=>zoom(1));
    dialog.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();show(selected+1);}else if(e.key==='ArrowLeft'){e.preventDefault();show(selected-1);}else if(e.key==='+'||e.key==='='){e.preventDefault();zoom(scale+.5);}else if(e.key==='-'){e.preventDefault();zoom(scale-.5);}});
    const observer=new ResizeObserver(edges);observer.observe(track);edges();
    document.addEventListener('shopify:section:unload',function unload(e){if(e.target.contains(root)){observer.disconnect();document.removeEventListener('shopify:section:unload',unload);}});
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpl-language-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const form = document.getElementById('TplCityLocalization');
  if (!form) return;
  const language = document.documentElement.lang.split('-')[0];
  const stripLocale = pathname => pathname.replace(/^\/(?:fr|en)(?=\/|$)/, '') || '/';
  const localized = (url, locale) => {
    url.pathname = (locale === 'en' ? '' : '/' + locale) + stripLocale(url.pathname);
    return url;
  };
  const updateLink = a => {
    const raw = a.getAttribute('href');
    if (!raw || raw.startsWith('#')) return;
    let url;
    try { url = new URL(raw, location.href); } catch { return; }
    if (url.origin !== location.origin) return;
    if (a.dataset.tplLanguage) {
      url = localized(new URL(location.href), a.dataset.tplLanguage);
      url.searchParams.delete('dc_lang');
      a.href = url.pathname + url.search + url.hash;
    } else if (language === 'fr' && /^\/(?:$|pages(?:\/|$)|products(?:\/|$)|collections(?:\/|$)|blogs(?:\/|$)|policies(?:\/|$)|cart(?:\/|$)|search(?:\/|$))/.test(stripLocale(url.pathname))) {
      url = localized(url, language);
      a.href = url.pathname + url.search + url.hash;
    }
  };
  const scan = root => {
    if (root.matches?.('a[href]')) updateLink(root);
    root.querySelectorAll?.('a[href]').forEach(updateLink);
  };
  scan(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => { if (node.nodeType === 1) scan(node); }))).observe(document.body, {childList:true,subtree:true});
  document.addEventListener('click', event => {
    const link = event.target.closest('a[data-tpl-language]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault();
    const url = localized(new URL(location.href), link.dataset.tplLanguage);
    url.searchParams.delete('dc_lang');
    form.elements.language_code.value = link.dataset.tplLanguage;
    form.elements.return_to.value = url.pathname + url.search + url.hash;
    form.requestSubmit();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpl-menu-cards"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = () => {
      const dialog = document.getElementById('TplSiteMenu');
      const rail = dialog?.querySelector('.tpl-menu-cards__rail');
      if (rail && !rail.dataset.ready) {
        rail.dataset.ready = 'true';
        const controls = dialog.querySelector('.tpl-menu-cards__controls');
        const previous = controls.querySelector('[data-tpl-cards-previous]');
        const next = controls.querySelector('[data-tpl-cards-next]');
        const reducedScroll = matchMedia('(prefers-reduced-motion: reduce)');
        const names = dialog.querySelector('.tpl-menu-names');
        const cards = [...rail.querySelectorAll('[data-tpl-card]')];
        let activeIndex = -1, requestedIndex = null, settleTimer;
        const links = [...names.querySelectorAll('[data-tpl-card-name]')];
        const select = index => {
          if (index === activeIndex || !links[index]) return;
          activeIndex = index;
          links.forEach((link, position) => { link.dataset.active = String(position === index); });
          const box = names.getBoundingClientRect(), label = links[index].getBoundingClientRect();
          if (label.left < box.left + 8 || label.right > box.right - 24) {
            names.scrollBy({ left: label.left - box.left - 8, behavior: reducedScroll.matches ? 'instant' : 'smooth' });
          }
        };
        const update = () => {
          const end = rail.scrollWidth - rail.clientWidth;
          controls.hidden = end <= 1;
          previous.disabled = rail.scrollLeft <= 1;
          next.disabled = rail.scrollLeft >= end - 1;
          if (requestedIndex !== null) { select(requestedIndex); return; }
          if (end > 1 && rail.scrollLeft >= end - 2) { select(cards.length - 1); return; }
          const start = rail.getBoundingClientRect().left;
          let nearest = 0, distance = Infinity;
          cards.forEach((card, index) => {
            const delta = Math.abs(card.getBoundingClientRect().left - start);
            if (delta < distance) { nearest = index; distance = delta; }
          });
          select(nearest);
        };
        const showCard = index => {
          index = Math.max(0, Math.min(cards.length - 1, index));
          requestedIndex = index;
          select(index);
          const delta = cards[index].getBoundingClientRect().left - rail.getBoundingClientRect().left;
          rail.scrollBy({ left: delta, behavior: reducedScroll.matches ? 'instant' : 'smooth' });
        };
        links.forEach((link, index) => {
          link.addEventListener('keydown', event => {
            let target;
            if (event.key === 'ArrowRight') target = index + 1;
            if (event.key === 'ArrowLeft') target = index - 1;
            if (event.key === 'Home') target = 0;
            if (event.key === 'End') target = cards.length - 1;
            if (target === undefined) return;
            event.preventDefault();
            target = Math.max(0, Math.min(cards.length - 1, target));
            showCard(target);
            links[target].focus({preventScroll:true});
          });
        });
        previous.addEventListener('click', () => showCard(activeIndex - 1));
        next.addEventListener('click', () => showCard(activeIndex + 1));
        const startBrowse = () => { requestedIndex = null; };
        rail.addEventListener('pointerdown', startBrowse, {passive:true});
        rail.addEventListener('touchstart', startBrowse, {passive:true});
        rail.addEventListener('wheel', startBrowse, {passive:true});
        rail.addEventListener('keydown', startBrowse);
        rail.addEventListener('scroll', () => {
          clearTimeout(settleTimer);
          settleTimer = setTimeout(update, 90);
        }, {passive:true});
        new ResizeObserver(update).observe(rail);
        update();
      }
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
    else init();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpl-moccasin-how-to-wear"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => document.querySelectorAll('[data-moccasin-looks]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const track = root.querySelector('[data-look-track]');
    const cards = [...root.querySelectorAll('[data-look-card]')];
    const links = [...root.querySelectorAll('[data-look-open]')];
    if (!cards.length) return;
    const prev = root.querySelector('[data-look-prev]'), next = root.querySelector('[data-look-next]');
    const count = root.querySelector('[data-look-count]');
    const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    const step = () => cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0);
    const current = () => Math.min(cards.length-1,Math.max(0,Math.round(track.scrollLeft / Math.max(1,step()))));
    const edges = () => { prev.disabled = track.scrollLeft < 2; next.disabled = track.scrollLeft >= track.scrollWidth-track.clientWidth-2; count.textContent = `${String(current()+1).padStart(2,'0')} / ${String(cards.length).padStart(2,'0')}`; };
    const go = n => track.scrollTo({left:Math.max(0,Math.min(cards.length-1,n))*step(),behavior:motion()});
    prev.addEventListener('click',()=>go(current()-1));next.addEventListener('click',()=>go(current()+1));
    track.addEventListener('scroll',edges,{passive:true});
    track.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=current()+1;else if(e.key==='ArrowLeft')n=current()-1;else if(e.key==='Home')n=0;else if(e.key==='End')n=cards.length-1;else return;e.preventDefault();go(n);});
    let drag=null,suppress=false;
    track.addEventListener('dragstart',e=>e.preventDefault());
    track.addEventListener('pointerdown',e=>{if(e.pointerType==='mouse'&&e.button===0)drag={x:e.clientX,left:track.scrollLeft,id:e.pointerId,moved:false};});
    track.addEventListener('pointermove',e=>{if(!drag||e.pointerId!==drag.id)return;const dx=e.clientX-drag.x;if(!drag.moved&&Math.abs(dx)<6)return;drag.moved=true;suppress=true;track.setPointerCapture(e.pointerId);track.classList.add('is-dragging');e.preventDefault();track.scrollLeft=drag.left-dx;});
    const end=()=>{drag=null;track.classList.remove('is-dragging');setTimeout(()=>{suppress=false;},0);};
    track.addEventListener('pointerup',end);track.addEventListener('pointercancel',end);track.addEventListener('lostpointercapture',end);
    track.addEventListener('click',e=>{if(suppress){e.preventDefault();e.stopImmediatePropagation();}},true);
    const dialog=root.querySelector('[data-look-dialog]'), full=root.querySelector('[data-look-full]'), stage=root.querySelector('[data-look-stage]');
    const close=root.querySelector('[data-look-close]'), dp=root.querySelector('[data-look-dialog-prev]'), dn=root.querySelector('[data-look-dialog-next]');
    const less=root.querySelector('[data-look-less]'), more=root.querySelector('[data-look-more]'), reset=root.querySelector('[data-look-reset]');
    let selected=0,scale=1,opener;
    const zoom=value=>{scale=Math.max(1,Math.min(2,value));stage.classList.toggle('is-zoomed',scale>1);full.style.width=scale>1?`${full.naturalWidth*scale}px`:'';full.style.height=scale>1?`${full.naturalHeight*scale}px`:'';reset.textContent=`${Math.round(scale*100)}%`;less.disabled=scale===1;more.disabled=scale===2;};
    const show=n=>{selected=Math.max(0,Math.min(links.length-1,n));const link=links[selected];full.src=link.href;full.alt=link.querySelector('img').alt;root.querySelector('[data-look-dialog-title]').textContent=link.dataset.lookTitle;zoom(1);dp.disabled=selected===0;dn.disabled=selected===links.length-1;stage.scrollTo(0,0);};
    links.forEach((link,i)=>link.addEventListener('click',e=>{if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;e.preventDefault();opener=link;show(i);dialog.showModal();close.focus();}));
    close.addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>{zoom(1);opener?.focus({preventScroll:true});});
    dp.addEventListener('click',()=>show(selected-1));dn.addEventListener('click',()=>show(selected+1));less.addEventListener('click',()=>zoom(scale-.5));more.addEventListener('click',()=>zoom(scale+.5));reset.addEventListener('click',()=>zoom(1));
    dialog.addEventListener('keydown',e=>{if(e.key==='ArrowRight'){e.preventDefault();show(selected+1);}else if(e.key==='ArrowLeft'){e.preventDefault();show(selected-1);}else if(e.key==='+'||e.key==='='){e.preventDefault();zoom(scale+.5);}else if(e.key==='-'){e.preventDefault();zoom(scale-.5);}});
    const observer=new ResizeObserver(edges);observer.observe(track);edges();
    document.addEventListener('shopify:section:unload',function unload(e){if(e.target.contains(root)){observer.disconnect();document.removeEventListener('shopify:section:unload',unload);}});
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpl-moccasin-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => document.querySelectorAll('[data-tpl-stitching]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const video = root.querySelector('video');
    const stage = root.querySelector('[data-stitching-stage]');
    const cover = root.querySelector('[data-stitching-cover]');
    const play = root.querySelector('[data-stitching-play]');
    const sound = root.querySelector('[data-stitching-sound]');
    const error = root.querySelector('[data-stitching-error]');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const hover = matchMedia('(hover: hover) and (pointer: fine)');
    let intent = 0;
    let manual = false;
    let stopped = false;
    let pending = false;
    video.controls = false;
    video.muted = true;
    root.querySelector('[data-stitching-controls]').hidden = false;
    const sync = () => {
      const active = !video.paused && !video.ended;
      play.textContent = active || pending ? root.dataset.pause : video.ended ? root.dataset.replay : root.dataset.play;
      cover.hidden = active || pending;
      sound.textContent = video.muted ? root.dataset.soundOn : root.dataset.soundOff;
      sound.setAttribute('aria-pressed', String(!video.muted));
    };
    const pause = () => { intent++; pending = false; video.pause(); sync(); };
    const start = async (automatic = false) => {
      const token = ++intent;
      pending = true;
      error.hidden = true;
      if (automatic) video.muted = true;
      if (!video.hasAttribute('src') || video.error) { video.src = video.dataset.src; video.load(); }
      if (video.ended) video.currentTime = 0;
      sync();
      try {
        await video.play();
        if (token !== intent) return;
      } catch (failure) {
        if (token === intent && !automatic && failure.name !== 'AbortError') error.hidden = false;
      }
      if (token === intent) { pending = false; sync(); }
    };
    const toggle = () => {
      manual = true;
      stopped = !video.paused || pending;
      if (stopped) pause(); else start();
    };
    cover.addEventListener('click', toggle);
    play.addEventListener('click', toggle);
    video.addEventListener('click', toggle);
    sound.addEventListener('click', () => {
      manual = true;
      stopped = false;
      video.muted = !video.muted;
      if (!video.muted && video.paused) start();
      sync();
    });
    stage.addEventListener('pointerenter', () => {
      if (hover.matches && !reduced.matches && !navigator.connection?.saveData && !manual && !stopped && !document.hidden) start(true);
    });
    stage.addEventListener('pointerleave', () => {
      if (!manual) pause();
    });
    ['play','pause','ended','volumechange'].forEach(event => video.addEventListener(event, sync));
    video.addEventListener('error', () => { pending = false; error.hidden = false; sync(); });
    document.addEventListener('visibilitychange', () => { if (document.hidden) { pause(); manual = false; video.muted = true; } });
    reduced.addEventListener?.('change', event => { if (event.matches && !manual) pause(); });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        if (!root.isConnected) { observer.disconnect(); pause(); return; }
        if (!entries[0].isIntersecting) { pause(); manual = false; video.muted = true; }
      });
      observer.observe(stage);
    }
    sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpl-product-browse"] && !Shopify.designMode) return;
  try {
    (() => {
  if(window.tplProductBrowser)return;
  const mobile=matchMedia('(max-width:989px)'),reduced=matchMedia('(prefers-reduced-motion:reduce)');
  const pages=new Map(),scripts=new Set(Array.from(document.querySelectorAll('script[src]')).map(script=>script.src));
  const inlineScripts=new Set(Array.from(document.querySelectorAll('#MainContent script:not([src])')).filter(script=>!script.type || script.type==='text/javascript').map(script=>script.textContent));
  let catalogPromise=null,controller=null,busy=false,currentUrl=location.href,renderedPath=location.pathname,requestToken=0,pendingPop=null;
  let status=document.createElement('p');status.className='tpl-product-swipe-status';status.setAttribute('role','status');document.body.append(status);
  const parseUrl=value=>{const url=new URL(value,location.origin);if(url.origin!==location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname))throw Error('product URL');return url;};
  const fetchPage=async value=>{
    const url=parseUrl(value),key=url.pathname+url.search,cached=pages.get(key);
    if(cached && Date.now()-cached.time<120000)return cached.promise;
    const promise=(async()=>{
      const response=await fetch(url.href,{credentials:'same-origin',signal:AbortSignal.timeout(10000)});
      if(!response.ok)throw Error('product');
      const html=await response.text(),doc=new DOMParser().parseFromString(html,'text/html');
      if(!doc.querySelector('#MainContent .tpl-pdp [data-tpl-product-browse]') || !doc.querySelector('#MainContent product-info'))throw Error('product markup');
      return html;
    })();
    pages.set(key,{time:Date.now(),promise});
    while(pages.size>5)pages.delete(pages.keys().next().value);
    try{return await promise;}catch(error){pages.delete(key);throw error;}
  };
  const catalog=rail=>{
    if(catalogPromise)return catalogPromise;
    catalogPromise=(async()=>{
      const url=new URL(rail.dataset.index,location.origin),key='tpl-product-browse-v1:'+url.pathname+':'+document.documentElement.lang;
      let pieces=[];
      try{const saved=JSON.parse(sessionStorage.getItem(key));if(saved && Date.now()-saved.time<300000)pieces=saved.pieces;}catch{}
      if(!Array.isArray(pieces)||pieces.length<2){
        pieces=[];let next=url.href;const visited=new Set();
        while(next && !visited.has(next) && visited.size<20){
          visited.add(next);const response=await fetch(next,{credentials:'same-origin',signal:AbortSignal.timeout(8000)});
          if(!response.ok)throw Error('catalog');const data=await response.json();if(!Array.isArray(data.products))throw Error('catalog');pieces.push(...data.products);
          if(data.next){const page=new URL(data.next,location.origin);if(page.origin!==location.origin)throw Error('origin');page.searchParams.set('view','tpl-product-browse');next=page.href;}else next=null;
        }
        try{sessionStorage.setItem(key,JSON.stringify({time:Date.now(),pieces}));}catch{}
      }
      return pieces.filter((piece,index,list)=>piece.handle && typeof piece.url==='string' && piece.url.startsWith('/') && !piece.url.startsWith('//') && list.findIndex(item=>item.handle===piece.handle)===index);
    })().catch(error=>{catalogPromise=null;throw error;});
    return catalogPromise;
  };
  const loadAssets=async main=>{
    for(const source of main.querySelectorAll('script[src]')){
      const url=new URL(source.getAttribute('src'),location.origin);
      if(scripts.has(url.href))continue;
      if(url.origin!==location.origin || !url.pathname.includes('/assets/'))continue;
      await new Promise((resolve,reject)=>{const script=document.createElement('script');script.src=url.href;script.onload=()=>{scripts.add(url.href);resolve();};script.onerror=()=>{script.remove();reject(Error('asset'));};document.head.append(script);});
    }
  };
  const updateMeta=doc=>{
    document.title=doc.title;
    for(const selector of ['link[rel="canonical"]','meta[name="description"]','meta[property="og:title"]','meta[property="og:url"]','meta[property="og:image"]','meta[property="og:description"]','meta[name="twitter:title"]','meta[name="twitter:description"]','meta[name="twitter:image"]']){
      const incoming=doc.querySelector(selector),existing=document.querySelector(selector);
      if(incoming){if(existing)existing.replaceWith(incoming.cloneNode(true));else document.head.append(incoming.cloneNode(true));}else existing?.remove();
    }
    document.body.id=doc.body.id;
  };
  const navigate=async(value,direction=1,pop=false)=>{
    if(busy){if(pop){pendingPop=value;++requestToken;}return false;}
    const target=parseUrl(value),main=document.getElementById('MainContent');
    if(!main)return false;
    busy=true;const token=++requestToken;status.textContent='';main.setAttribute('aria-busy','true');document.dispatchEvent(new Event('tpl:navigation:start'));
    try{
      const html=await fetchPage(target.href),doc=new DOMParser().parseFromString(html,'text/html'),next=doc.getElementById('MainContent');
      await loadAssets(next);
      const hero=next.querySelector('.tpl-pdp--editorial [data-tpl-editorial-swipe] img,.tpl-pdp .product-gallery img');
      if(hero){const image=new Image();image.src=hero.getAttribute('src');await Promise.race([image.decode().catch(()=>{}),new Promise(resolve=>setTimeout(resolve,650))]);}
      if(token!==requestToken)return false;
      if(!pop)history.replaceState({...history.state,tplProduct:true,scrollY:window.scrollY},'',location.href);
      controller?.abort();
      main.querySelectorAll('product-info').forEach(info=>{info.flkty?.destroy();info.flktyNav?.destroy();info.flkty=null;info.flktyNav=null;});
      main.querySelectorAll('.shopify-section').forEach(section=>section.dispatchEvent(new CustomEvent('shopify:section:unload',{bubbles:true,detail:{sectionId:section.id.replace('shopify-section-','')}})));
      const update=()=>{
        main.replaceChildren(...Array.from(next.childNodes));
        main.dataset.tplProductTransitions=String(Number(main.dataset.tplProductTransitions || 0)+1);
        if(!pop)history.pushState({tplProduct:true,scrollY:0},'',target.href);
        currentUrl=target.href;renderedPath=target.pathname;updateMeta(doc);
        main.querySelectorAll('script:not([src])').forEach(source=>{
          if(source.type && source.type!=='text/javascript')return;
          if(inlineScripts.has(source.textContent))return;
          inlineScripts.add(source.textContent);const script=document.createElement('script');script.textContent=source.textContent;source.replaceWith(script);
        });
        main.querySelectorAll('.shopify-section').forEach(section=>section.dispatchEvent(new CustomEvent('shopify:section:load',{bubbles:true,detail:{sectionId:section.id.replace('shopify-section-','')}})));
        window.Shopify?.PaymentButton?.init();
        const heading=main.querySelector('h1');if(heading){heading.tabIndex=-1;heading.focus({preventScroll:true,focusVisible:false});}
        window.scrollTo({top:pop?(history.state?.scrollY || 0):0,behavior:'instant'});
        document.dispatchEvent(new CustomEvent('tpl:product:changed',{detail:{url:target.href,handle:main.querySelector('[data-tpl-product-browse]').dataset.handle}}));
      };
      update();
      const section=main.querySelector('.tpl-pdp');
      if(!reduced.matches)section.animate([{opacity:.55,transform:`translateX(${direction*38}px)`},{opacity:1,transform:'translateX(0)'}],{duration:260,easing:'cubic-bezier(.22,1,.36,1)'});
      return true;
    }catch(error){
      status.textContent=main.querySelector('[data-tpl-product-browse]')?.dataset.error || '';
      if(pop)history.replaceState({...history.state,tplProduct:true},'',currentUrl);
      return false;
    }finally{busy=false;main.removeAttribute('aria-busy');document.dispatchEvent(new Event('tpl:navigation:end'));if(pendingPop){const pending=pendingPop;pendingPop=null;navigate(pending,0,true);}}
  };
  const initialize=async section=>{
    const rail=section.querySelector('[data-tpl-product-browse]');if(!rail || rail.dataset.initialized)return;
    rail.dataset.initialized='true';
    try{
      const pieces=await catalog(rail);if(!section.isConnected)return;
      const current=pieces.findIndex(piece=>piece.handle===rail.dataset.handle);if(current<0 || pieces.length<2)return;
      const previous=pieces[(current-1+pieces.length)%pieces.length],next=pieces[(current+1)%pieces.length];
      controller?.abort();controller=new AbortController();const signal=controller.signal;
      const prevLink=rail.querySelector('[data-tpl-piece-prev]'),nextLink=rail.querySelector('[data-tpl-piece-next]');
      [[prevLink,previous,-1],[nextLink,next,1]].forEach(([link,piece,direction])=>{link.href=piece.url;link.setAttribute('aria-label',link.textContent.trim()+' — '+piece.title);link.addEventListener('click',event=>{if(event.metaKey || event.ctrlKey || event.shiftKey)return;event.preventDefault();navigate(link.href,direction);},{signal});});
      rail.hidden=false;history.scrollRestoration='manual';
      const info=section.querySelector('product-info');let start=null,suppressUntil=0;
      // Only the opening photograph changes pieces. Information, later photographs,
      // process archives and purchase controls keep their own native gestures.
      const swipeZone=section.querySelector('.tpl-editorial-product__hero') || section.querySelector('.product-gallery [data-product-single-media-wrapper]');
      if(swipeZone)swipeZone.setAttribute('data-tpl-product-swipe-zone','');
      const verticalMedia=()=>{
        if(!section.isConnected)return;
        section.classList.toggle('tpl-browse-ready',mobile.matches);
        if(mobile.matches && info){
          info.flkty?.destroy();info.flktyNav?.destroy();info.flkty=null;info.flktyNav=null;
          section.querySelectorAll('[data-product-single-media-wrapper]').forEach(slide=>{slide.style.setProperty('--tpl-media-ratio',slide.dataset.aspectratio || '1');slide.removeAttribute('aria-hidden');slide.classList.remove('media--hidden');slide.querySelectorAll('a,button').forEach(el=>el.removeAttribute('tabindex'));});
        }else if(info && !info.flkty)info.checkSlider?.();
      };
      verticalMedia();
      document.addEventListener('theme:resize:width',()=>requestAnimationFrame(verticalMedia),{signal});mobile.addEventListener('change',verticalMedia,{signal});
      const prefetch=()=>{if(mobile.matches && !navigator.connection?.saveData){fetchPage(previous.url).catch(()=>{});fetchPage(next.url).catch(()=>{});}};
      prefetch();
      const excluded=target=>target.closest('button,input,select,textarea,summary,video,model-viewer,dialog,[role="dialog"],.tpl-product-browse,.product-single__thumbnails') || (target.closest('a') && !target.closest('.product-gallery__media-link,[data-zoom-wrapper],[data-tpl-image-enlarge]'));
      const begin=(target,x,y,id)=>{
        start=null;if(!mobile.matches || busy || !swipeZone?.contains(target) || excluded(target) || document.querySelector('dialog[open],.pswp--open,[data-tpl-guide-overlay][aria-hidden="false"]'))return;
        if(x<24 || x>innerWidth-24)return;start={x,y,time:performance.now(),id,cancelled:false};
      };
      const move=(x,y,event)=>{if(!start)return;const dx=x-start.x,dy=y-start.y;if(Math.abs(dy)>18 && Math.abs(dy)>Math.abs(dx)*.75)start.cancelled=true;if(!start.cancelled && Math.abs(dx)>18 && Math.abs(dx)>Math.abs(dy)*1.5 && event.cancelable)event.preventDefault();};
      const finish=(x,y,id,event)=>{if(!start)return;const gesture=start;start=null;if(gesture.id!==id || gesture.cancelled)return;const dx=x-gesture.x,dy=y-gesture.y;if(Math.abs(dx)<70 || Math.abs(dx)<Math.abs(dy)*1.7 || performance.now()-gesture.time>1200)return;if(event.cancelable)event.preventDefault();suppressUntil=Date.now()+700;navigate(dx<0?nextLink.href:prevLink.href,dx<0?1:-1);};
      if(!swipeZone)return;
      swipeZone.addEventListener('touchstart',event=>{start=null;if(event.touches.length!==1)return;const t=event.touches[0];begin(event.target,t.clientX,t.clientY,t.identifier);},{passive:true,signal});
      swipeZone.addEventListener('touchmove',event=>{if(event.touches.length!==1){start=null;return;}const t=event.touches[0];move(t.clientX,t.clientY,event);},{passive:false,signal});
      swipeZone.addEventListener('touchcancel',()=>{start=null;},{passive:true,signal});
      swipeZone.addEventListener('touchend',event=>{if(!start)return;const t=Array.from(event.changedTouches).find(t=>t.identifier===start.id);if(t)finish(t.clientX,t.clientY,t.identifier,event);},{passive:false,signal});
      swipeZone.addEventListener('pointerdown',event=>{if(event.pointerType!=='mouse' || event.button!==0)return;begin(event.target,event.clientX,event.clientY,'mouse');},{signal});
      swipeZone.addEventListener('pointermove',event=>{
        if(start?.id!=='mouse')return;
        move(event.clientX,event.clientY,event);
        if(start && !start.cancelled && Math.abs(event.clientX-start.x)>18 && Math.abs(event.clientX-start.x)>Math.abs(event.clientY-start.y)*1.5)swipeZone.setPointerCapture(event.pointerId);
      },{signal});
      swipeZone.addEventListener('pointerup',event=>{if(start?.id==='mouse')finish(event.clientX,event.clientY,'mouse',event);},{signal});
      swipeZone.addEventListener('pointercancel',event=>{if(event.pointerType==='mouse')start=null;},{signal});
      swipeZone.addEventListener('lostpointercapture',()=>{start=null;},{signal});
      swipeZone.addEventListener('dragstart',event=>{if(start)event.preventDefault();},{signal});
      swipeZone.addEventListener('click',event=>{if(Date.now()<suppressUntil){event.preventDefault();event.stopImmediatePropagation();}}, {capture:true,signal});
    }catch{delete rail.dataset.initialized;}
  };
  const boot=()=>document.querySelectorAll('#MainContent .tpl-pdp').forEach(initialize);
  window.tplProductBrowser={navigate};
  addEventListener('popstate',()=>{if(location.pathname!==renderedPath && /\/products\//.test(location.pathname))navigate(location.href,0,true);});
  addEventListener('pagehide',()=>{history.replaceState({...history.state,scrollY:window.scrollY},'',location.href);});
  document.addEventListener('shopify:section:load',boot);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpl-product-complements"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => document.querySelectorAll('[data-tpl-size-edit]').forEach(root => {
    if (root.dataset.ready) return;
    const grid = root.querySelector('[data-tpl-complement-grid]');
    const filter = root.querySelector('[data-tpl-size-filter]');
    const label = root.querySelector('[data-tpl-size-label]');
    const picker = root.querySelector('[data-tpl-size-picker]');
    const status = root.querySelector('[data-tpl-size-status]');
    const strings = JSON.parse(root.querySelector('[data-tpl-size-strings]').textContent);
    const cards = [...grid.children].map(node => node.tagName === 'TEMPLATE' ? node.content.querySelector('article') : node).filter(node => node?.matches('[data-tpl-complement-card]'));
    const entries = cards.map(card => ({ card: card.cloneNode(true), variants: JSON.parse(card.dataset.variants) }));
    const buckets = new Map();
    entries.forEach(entry => entry.variants.forEach(variant => {
      if (variant.group === 'unsized') return;
      if (!buckets.has(variant.group)) buckets.set(variant.group, new Set());
      buckets.get(variant.group).add(variant.size);
    }));
    if (!buckets.size) return;
    root.dataset.ready = 'true';
    const shoeSize = size => {
      const eu = Number(size.replace(/^EU\s*/i, '').trim());
      return Number.isFinite(eu) && eu >= 40 && eu <= 47 ? 'EU ' + eu + ' / US ' + (eu - 33) : 'EU ' + size.replace(/^EU\s*/i, '');
    };
    const controls = [];
    const show = (group = '', size = '') => {
      const matches = entries.map(entry => ({ ...entry, selected: entry.variants.find(variant => variant.group === group && (!size || variant.size === size)) })).filter(entry => !group || entry.selected).slice(0, 3);
      grid.replaceChildren(...matches.map(entry => {
        const card = entry.card.cloneNode(true);
        if (entry.selected && size) {
          card.querySelectorAll('[data-tpl-complement-link],[data-tpl-quick-shop]').forEach(link => {
            const isQuick = link.hasAttribute('data-tpl-quick-shop');
            const url = new URL(isQuick ? link.dataset.tplQuickShop : link.getAttribute('href'), location.origin);
            url.searchParams.set('variant', entry.selected.id);
            if (isQuick) link.dataset.tplQuickShop = url.pathname + url.search;
            else link.setAttribute('href', url.pathname + url.search);
          });
          const price = card.querySelector('template[data-tpl-variant-price="' + entry.selected.id + '"]');
          if (price) card.querySelector('[data-tpl-complement-price]')?.replaceChildren(price.content.cloneNode(true));
        }
        return card;
      }));
      const sizeLabel = !size ? '' : size === 'one_size' ? strings.one_size : group === 'shoes' ? shoeSize(size) : size;
      label.textContent = group ? strings[group] + (sizeLabel ? ' · ' + sizeLabel : '') : strings.your_size;
      controls.forEach(control => control.setAttribute('aria-pressed', String(control.dataset.group === group && control.dataset.size === size)));
      root.querySelector('[data-tpl-size-empty]').hidden = matches.length > 0;
      grid.hidden = matches.length === 0;
      status.textContent = group ? strings[group] + ' · ' + matches.length + ' · ' + strings.available + ' ' + sizeLabel : '';
      filter.open = false;
      grid.scrollLeft = 0;
    };
    const button = (group, size, text) => {
      const control = document.createElement('button'); control.type = 'button'; control.textContent = text;
      control.dataset.group = group; control.dataset.size = size; control.setAttribute('aria-pressed', String(!group));
      if (group) control.setAttribute('aria-label', strings[group] + ' · ' + text);
      control.addEventListener('click', () => { show(group, size); filter.querySelector('summary').focus({ preventScroll: true }); });
      controls.push(control); return control;
    };
    picker.append(button('', '', strings.all));
    const alphaSizes = ['XXS','XS','S','M','L','XL','XXL','XXXL','4XL','5XL'];
    for (const group of ['shoes','clothing','headwear','accessories']) {
      if (!buckets.has(group)) continue;
      const field = document.createElement('fieldset');
      const legend = document.createElement('legend'); legend.textContent = strings[group]; field.append(legend);
      const choices = document.createElement('div'); choices.className = 'tpl-size-edit__choices';
      if (group === 'shoes') choices.append(button(group, '', strings.all_footwear));
      const values = [...buckets.get(group)].sort((a,b) => {
        if (a === 'one_size') return 1;
        if (b === 'one_size') return -1;
        const aIndex = alphaSizes.indexOf(a.toUpperCase()), bIndex = alphaSizes.indexOf(b.toUpperCase());
        if (aIndex >= 0 && bIndex >= 0) return aIndex - bIndex;
        if (aIndex >= 0) return -1;
        if (bIndex >= 0) return 1;
        return a.localeCompare(b, undefined, { numeric: true });
      });
      values.forEach(size => choices.append(button(group, size, size === 'one_size' ? strings.one_size : group === 'shoes' ? shoeSize(size) : size)));
      field.append(choices);
      if (group === 'shoes') { const note = document.createElement('p'); note.className = 'tpl-size-edit__shoe-note'; note.textContent = strings.shoe_note; field.append(note); }
      picker.append(field);
    }
    filter.addEventListener('keydown', event => { if (event.key === 'Escape') { filter.open = false; filter.querySelector('summary').focus(); } });
    root.querySelector('[data-tpl-size-join]').hidden = false; filter.hidden = false;
    show();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('tpl:product:changed', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpl-product-design"] && !Shopify.designMode) return;
  try {
    (() => {
  const organize = () => document.querySelectorAll('.tpl-pdp').forEach(section => {
    const guide = section.querySelector('[data-tpl-knit-guide]');
    const description = section.querySelector('.tpl-pdp-description');
    const nativeGuide = section.querySelector('.product__form__size-chart');
    const nativeDrawer = section.querySelector('.popup-chart');
    const nativeTrigger = section.querySelector('.product__popup__link[aria-controls^="size-chart"]');
    if (nativeDrawer && nativeTrigger && !nativeDrawer.dataset.tplFocusReturn) {
      nativeDrawer.dataset.tplFocusReturn = 'true';
      new MutationObserver(() => {
        if (nativeDrawer.getAttribute('aria-hidden') !== 'true') return;
        setTimeout(() => {
          if (document.activeElement === document.body || nativeDrawer.contains(document.activeElement)) nativeTrigger.focus({preventScroll:true});
        }, 0);
      }).observe(nativeDrawer, {attributes:true, attributeFilter:['aria-hidden']});
    }

    if (!guide && nativeGuide) {
      const variants = section.querySelector('variant-selects');
      if (variants) variants.after(nativeGuide);
      nativeGuide.classList.add('tpl-pdp-guide');
    }
    section.querySelectorAll('.product__accordion').forEach(accordion => {
      const trigger = accordion.querySelector('button');
      if (!trigger || !/^(size|size\s*(?:&|and)\s*fit)$/i.test(trigger.textContent.trim())) return;
      const content = accordion.querySelector('.product__accordion__inner');
      const target = guide ? guide.querySelector('.tpl-knit-guide__body') : section.querySelector('.popup-chart__content');
      if (content && target && !target.querySelector('.tpl-size-fit-note')) {
        const note = document.createElement('div'); note.className = 'tpl-size-fit-note';
        note.append(...Array.from(content.childNodes)); const heading = target.querySelector('.tpl-size-guide-title'); if (heading) heading.after(note); else target.prepend(note); accordion.hidden = true;
      }
    });
    if (!guide || !description || guide.parentElement.classList.contains('tpl-pdp-guide')) return;
    const holder = document.createElement('div');
    holder.className = 'tpl-pdp-guide';
    description.before(holder);
    holder.append(guide);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', organize, {once:true}); else organize();
  document.addEventListener('shopify:section:load', organize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpl-product-editorial"] && !Shopify.designMode) return;
  try {
    (() => {

  const initInformation = () => document.querySelectorAll('[data-tpl-product-information]').forEach(root => {
    if (root.classList.contains('is-enhanced')) return;
    const navigation = root.querySelector('[data-tpl-info-navigation]');
    const tabs = root.querySelector('[data-tpl-info-tabs]');
    const buttons = Array.from(tabs.querySelectorAll('[role=tab]'));
    const panels = Array.from(root.querySelectorAll('[data-tpl-info-panel]'));
    const previous = root.querySelector('[data-tpl-info-previous]');
    const next = root.querySelector('[data-tpl-info-next]');
    const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    const edges = () => {
      const max = tabs.scrollWidth - tabs.clientWidth;
      previous.disabled = tabs.scrollLeft <= 2;
      next.disabled = tabs.scrollLeft >= max - 2;
    };
    const measure = () => {
      navigation.classList.remove('is-overflowing');
      navigation.classList.toggle('is-overflowing', tabs.scrollWidth > tabs.clientWidth + 2);
      edges();
    };
    const reveal = button => {
      const track = tabs.getBoundingClientRect(), item = button.getBoundingClientRect();
      const delta = item.left < track.left ? item.left - track.left : item.right > track.right ? item.right - track.right : 0;
      if (delta) tabs.scrollBy({left:delta, behavior:motion()});
    };
    const select = (index, scroll = true) => {
      buttons.forEach((button, i) => { button.setAttribute('aria-selected', String(i === index)); button.tabIndex = i === index ? 0 : -1; });
      panels.forEach((panel, i) => { panel.hidden = i !== index; panel.setAttribute('role', 'tabpanel'); panel.tabIndex = 0; });
      if (scroll) reveal(buttons[index]);
    };
    root.classList.add('is-enhanced');
    navigation.hidden = false;
    select(0, false);
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => select(index));
      button.addEventListener('keydown', event => {
        let target;
        if (event.key === 'ArrowRight') target = (index + 1) % buttons.length;
        else if (event.key === 'ArrowLeft') target = (index + buttons.length - 1) % buttons.length;
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = buttons.length - 1;
        else return;
        event.preventDefault(); select(target); buttons[target].focus({preventScroll:true});
      });
    });
    document.querySelectorAll('[data-tpl-info-shortcut]').forEach(link => {
      const index = panels.findIndex(panel => panel.id === link.getAttribute('aria-controls'));
      if (index < 0) return;
      link.addEventListener('click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); select(index);
        if (!root.contains(link)) navigation.scrollIntoView({behavior:motion(), block:'start'});
        panels[index].focus({preventScroll:true});
      });
    });
    previous.addEventListener('click', () => tabs.scrollBy({left:-tabs.clientWidth * .75, behavior:motion()}));
    next.addEventListener('click', () => tabs.scrollBy({left:tabs.clientWidth * .75, behavior:motion()}));
    tabs.addEventListener('scroll', edges, {passive:true});
    let drag = null, suppressClick = false;
    tabs.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      drag = {x:event.clientX, left:tabs.scrollLeft, id:event.pointerId, moved:false};
    });
    tabs.addEventListener('pointermove', event => {
      if (!drag || event.pointerId !== drag.id) return;
      const delta = event.clientX - drag.x;
      if (!drag.moved && Math.abs(delta) < 6) return;
      drag.moved = true; suppressClick = true;
      tabs.setPointerCapture(event.pointerId); tabs.classList.add('is-dragging');
      event.preventDefault(); tabs.scrollLeft = drag.left - delta;
    });
    const release = () => { drag = null; tabs.classList.remove('is-dragging'); setTimeout(() => { suppressClick = false; }, 0); };
    tabs.addEventListener('pointerup', release);
    tabs.addEventListener('pointercancel', release);
    tabs.addEventListener('lostpointercapture', release);
    tabs.addEventListener('pointerleave', () => { if (drag && !drag.moved) release(); });
    tabs.addEventListener('click', event => { if (suppressClick) { event.preventDefault(); event.stopImmediatePropagation(); } }, true);
    measure();
    const resize = new ResizeObserver(measure); resize.observe(root);
    document.fonts?.ready.then(() => { if (root.isConnected) measure(); });
    const unload = event => { if (event.target.contains(root)) { resize.disconnect(); document.removeEventListener('shopify:section:unload', unload); } };
    document.addEventListener('shopify:section:unload', unload);
  });
  const init=()=>document.querySelectorAll('[data-tpl-editorial-product]').forEach(root=>{
    if(root.classList.contains('is-enhanced'))return;
    root.classList.add('is-enhanced');
    const modelDialog=root.querySelector('[data-tpl-model-dialog]'),modelOpen=root.querySelector('[data-tpl-model-open]');
    if(modelDialog){
      modelOpen.addEventListener('click',()=>{modelDialog.showModal();const mount=root.querySelector('[data-tpl-model-mount]');if(mount.children.length)return;mount.append(root.querySelector('[data-tpl-model-template]').content.cloneNode(true));const status=root.querySelector('[data-tpl-model-status]');if(window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'model-viewer-ui',version:'1.0',onLoad:error=>{if(error)status.hidden=false;}}]);else status.hidden=false;});
      root.querySelector('[data-tpl-model-close]').addEventListener('click',()=>modelDialog.close());modelDialog.addEventListener('close',()=>modelOpen.focus({preventScroll:true}));
      root.querySelector('[data-tpl-model-add]').addEventListener('click',()=>{modelDialog.close();document.querySelector('[data-tpl-purchase-add]')?.click();});
    }
  });
  const initialize = () => { initInformation(); init(); };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpl-product-share"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => document.querySelectorAll('[data-tpl-piece-share]').forEach(root => {
    if (root.dataset.ready) return;
    const summary = root.querySelector('summary');
    const copy = root.querySelector('[data-tpl-share-copy]');
    const email = root.querySelector('[data-tpl-share-email]');
    const status = root.querySelector('[data-tpl-share-status]');
    const manual = root.querySelector('[data-tpl-share-manual]');
    const input = manual.querySelector('input');
    const variants = JSON.parse(root.dataset.variants).map(String);
    root.dataset.ready = 'true'; copy.hidden = false;
    const shareUrl = () => {
      const url = new URL(root.dataset.url, location.origin);
      url.search = ''; url.hash = '';
      const current = new URL(location.href);
      const variant = current.searchParams.get('variant');
      if (variants.includes(variant)) url.searchParams.set('variant', variant);
      const preview = current.searchParams.get('preview_theme_id');
      if (preview && preview === root.dataset.themeId) url.searchParams.set('preview_theme_id', preview);
      return url.href;
    };
    const updateLinks = () => {
      const url = shareUrl(); input.value = url;
      email.href = 'mailto:?subject=' + encodeURIComponent(root.dataset.title) + '&body=' + encodeURIComponent(root.dataset.message + '\n\n' + url);
      return url;
    };
    updateLinks();
    let sharing = false;
    summary.addEventListener('click', async event => {
      updateLinks(); status.textContent = ''; manual.hidden = true;
      if (!navigator.share || root.open) return;
      event.preventDefault();
      if (sharing) return;
      sharing = true;
      try { await navigator.share({ title: root.dataset.title, text: root.dataset.message, url: shareUrl() }); }
      catch (cause) { if (cause.name !== 'AbortError') root.open = true; }
      finally { sharing = false; }
    });
    copy.addEventListener('click', async () => {
      const url = updateLinks(); status.textContent = '';
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(url);
        manual.hidden = true; status.textContent = root.dataset.copied;
      } catch {
        manual.hidden = false; input.focus(); input.select(); status.textContent = root.dataset.manual;
      }
    });
    email.addEventListener('click', updateLinks);
    root.addEventListener('keydown', event => { if (event.key === 'Escape' && root.open) { root.open = false; summary.focus(); } });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('tpl:product:changed', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpl-quick-purchase"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('TplPurchaseDialog');
  if (!dialog || !dialog.showModal) return;
  const strings = JSON.parse(dialog.querySelector('[data-tpl-purchase-strings]').textContent);
  const shoeReference = JSON.parse(dialog.querySelector('[data-tpl-shoe-data]').textContent);
  const shoeStrings = JSON.parse(dialog.querySelector('[data-tpl-shoe-strings]').textContent);
  const fitStrings = JSON.parse(dialog.querySelector('[data-tpl-fit-strings]').textContent);
  const isDerby = product => product.handle === 'the-legacy-derby';
  const isMensTee = product => product.handle === 'the-proper-label-signature-tee-white';
  const isMensMoccasin = product => String(product.id) === shoeReference.productId;
  const isWomensMoccasin = product => String(product.id) === shoeReference.women.productId;
  const isMoccasin = product => isMensMoccasin(product) || isWomensMoccasin(product);
  const isFootwear = product => state?.sale?.footwear === true || isMoccasin(product);
  const usSize = (product,eu) => { const map = isWomensMoccasin(product) ? shoeReference.women.map : shoeReference.map; return /^\d{1,2}(?:\.5)?$/.test(map[String(eu)] || '') ? map[String(eu)] : ''; };
  const displayUS = (product,eu) => isMoccasin(product) ? usSize(product,eu) : isDerby(product) && /^\d{2}(?:\.5)?$/.test(String(eu)) ? String(Number(eu)-33) : '';
  const root = (dialog.dataset.root || '/').replace(/\/?$/, '/');
  const heading = dialog.querySelector('h2');
  const subtitle = dialog.querySelector('[data-tpl-purchase-subtitle]');
  const options = dialog.querySelector('[data-tpl-purchase-options]');
  const isPreorder = variant => !!state?.sale?.variants?.[String(variant?.id)]?.preorder;
  const terms = dialog.querySelector('[data-tpl-purchase-terms]');
  const success = dialog.querySelector('[data-tpl-purchase-success]');
  const error = dialog.querySelector('[data-tpl-purchase-error]');
  const status = dialog.querySelector('[data-tpl-purchase-status]');
  const productLink = dialog.querySelector('[data-tpl-purchase-product]');
  const notification = dialog.querySelector('[data-tpl-size-notification]');
  const notificationStrings = JSON.parse(notification.querySelector('[data-tpl-notification-strings]').textContent);
  const notificationForm = notification.querySelector('[data-tpl-notification-form]');
  const notificationEmail = notificationForm.querySelector('[name=email]');
  const notificationRequest = notification.querySelector('[data-tpl-notification-request]');
  const notificationSuccess = notification.querySelector('[data-tpl-notification-success]');
  const chosen = new Map();
  const renderTitle = product => {
    heading.textContent = product.title;
    if (['8694452715698','8751186313394'].includes(String(product.id))) {
      const accent = document.createElement('em');
      accent.className = 'tpl-piece-title__accent'; accent.textContent = String(product.id) === '8751186313394' ? 'pour lui' : 'pour elle';
      heading.replaceChildren(document.createTextNode(product.title.split(' — ')[0] + ' — '), accent);
    }
  };
  let state = null, busy = false, opener = null, token = 0, handingToCart = false;
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:dialog.dataset.currency || 'USD'}).format(value / 100);
  const request = async (url, init) => {
    const controller = new AbortController();
    // Bound read requests; never automatically retry a cart write.
    const timeout = !init?.method || init.method === 'GET' ? setTimeout(() => controller.abort(), 15000) : null;
    try {
      const response = await fetch(url, {...init, credentials:'same-origin', signal:controller.signal, headers:{'Accept':'application/json', ...(init?.headers || {})}});
      const data = await response.json().catch(() => { throw new Error(strings.error); });
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : typeof data.message === 'string' ? data.message : strings.error);
      return data;
    } catch (cause) {
      if (cause.name === 'AbortError' || cause instanceof TypeError) throw new Error(strings.error);
      throw cause;
    } finally { if (timeout !== null) clearTimeout(timeout); }
  };
  const setBusy = value => { busy = value; dialog.setAttribute('aria-busy', String(value)); status.textContent = value ? strings.working : ''; };
  const show = () => { if (!dialog.open) dialog.showModal(); };
  const reset = () => { error.textContent=''; status.textContent=''; options.hidden=false; terms.hidden=true; success.hidden=true; notification.hidden=true; notificationForm.reset(); dialog.querySelector('.tpl-purchase-dialog__tax').hidden=false; productLink.hidden=true; options.replaceChildren(); };
  const showAvailability = variant => {
    if (!isFootwear(state.product) || variant.available) return;
    state.variant = null; state.notificationVariant = variant;
    options.hidden=true; terms.hidden=true; success.hidden=true; notification.hidden=false;
    notificationRequest.hidden=false; notificationSuccess.hidden=true; notificationForm.reset();
    dialog.querySelector('.tpl-purchase-dialog__tax').hidden=true;
    error.textContent=''; status.textContent=''; renderTitle(state.product); updateBar(variant);
    subtitle.textContent='EU '+variant.title+' · '+notificationStrings.unavailable;
    const url = new URL(state.product.url || productLink.href, location.origin);
    url.searchParams.set('variant', variant.id);
    if(state.main){const currentUrl=new URL(location.href);currentUrl.searchParams.set('variant',variant.id);history.replaceState(history.state,'',currentUrl.pathname+currentUrl.search+currentUrl.hash);}
    const subject=notificationStrings.subject+' — '+state.product.title+' — EU '+variant.title;
    notification.querySelector('[data-tpl-notification-assistance]').href='mailto:concierge@theproperlabel.us?subject='+encodeURIComponent(subject)+'&body='+encodeURIComponent(notificationStrings.mail_body+'\n\n'+state.product.title+' · EU '+variant.title+'\n'+url.href);
    notificationEmail.focus({preventScroll:true});
  };
  const updateBar = variant => {
    if (!state.main) return;
    const bar = document.querySelector('[data-tpl-purchase-bar]');
    if (!bar) return;
    bar.querySelector('[data-tpl-purchase-price]').textContent=money(variant.price);
    const isEuShoe = isFootwear(state.product) || state.product.options.some(option => ['shoe size','pointure'].includes(String(option.name || option).toLowerCase()));
    bar.querySelector('[data-tpl-purchase-size]').textContent=variant.title === 'Default Title' ? '' : (isEuShoe ? (displayUS(state.product,variant.title) ? 'US '+displayUS(state.product,variant.title)+' | ' : '')+'EU ' : '') + variant.title;
    document.dispatchEvent(new CustomEvent('tpl:purchase-variant',{detail:{productId:state.product.id,variantId:variant.id}}));
  };
  const showTerms = () => {
    options.hidden=true; terms.hidden=false; success.hidden=true; heading.textContent=strings.terms;
    subtitle.textContent=state.product.title+' · '+money(state.variant.price);
    dialog.querySelector('[data-tpl-purchase-back]').focus();
  };
  const refreshCart = () => document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
  const add = async (checkout = false) => {
    if (busy || !state?.variant?.available) return;
    setBusy(true); error.textContent='';
    try {
      let inCart = false;
      if (checkout) {
        const cart = await request(root+'cart.js');
        inCart = cart.items.some(item => String(item.variant_id) === String(state.variant.id) && !item.selling_plan_allocation);
      }
      if (!inCart) await request(root+'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:state.variant.id,quantity:1,...(isPreorder(state.variant)?{properties:{[strings.order_type]:strings.preorder}}:{})}]})});
      if (checkout) { window.location.assign(root+'checkout'); return; }

      options.hidden=true; terms.hidden=true; success.hidden=false; subtitle.textContent=state.variant.title === 'Default Title' ? '' : state.variant.title;
      refreshCart();
      dialog.querySelector('.tpl-purchase-dialog__selection').focus();
    } catch (cause) { error.textContent=cause.message || strings.error; }
    finally { setBusy(false); }
  };
  const selectVariant = variant => {
    if(!variant.available){if(isFootwear(state.product))showAvailability(variant);else{error.textContent=strings.unavailable;productLink.hidden=false;}return;}
    state.variant=variant; chosen.set(state.product.id,variant.id); updateBar(variant);
    if(state.main){const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState(history.state,'',url.pathname+url.search+url.hash);}
    if (isFootwear(state.product)) { renderOptions(); options.querySelector('[data-shoe-value][aria-pressed=true]')?.focus({preventScroll:true}); }
    else if (!state.main) { renderOptions(); options.querySelector('[aria-pressed=true]')?.focus({preventScroll:true}); }
    else if (state.intent === 'pay') showTerms(); else add();
  };
  const enhanceSizeRail = rail => {
    let drag = null, moved = false;
    rail.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      drag = { x:event.clientX, left:rail.scrollLeft }; moved = false;
    });
    rail.addEventListener('pointermove', event => {
      if (!drag || !event.buttons) { drag = null; return; }
      const delta = event.clientX - drag.x;
      if (Math.abs(delta) > 6) { moved = true; rail.setPointerCapture(event.pointerId); }
      if (moved) { event.preventDefault(); rail.scrollLeft = drag.left - delta; }
    });
    rail.addEventListener('pointerup', () => { drag = null; });
    rail.addEventListener('pointercancel', () => { drag = null; moved = false; });
    rail.addEventListener('click', event => { if (moved) { event.preventDefault(); event.stopImmediatePropagation(); moved = false; } }, true);
    rail.addEventListener('keydown', event => {
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      const buttons = [...rail.querySelectorAll('button:not(:disabled)')];
      const current = buttons.indexOf(event.target); if (current < 0) return;
      event.preventDefault();
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : Math.max(0,Math.min(buttons.length - 1,current + (event.key === 'ArrowRight' ? 1 : -1)));
      buttons[next]?.focus({preventScroll:true}); buttons[next]?.scrollIntoView({block:'nearest',inline:'nearest'});
    });
  };
  const renderOptions = () => {
    const openHelp = [...options.querySelectorAll('details[open]')].map(el => el.querySelector('summary')?.textContent);
    options.replaceChildren(); renderTitle(state.product);
    const product = state.product, moccasin = isMoccasin(product), footwear = isFootwear(product);
    const womensShoes = isWomensMoccasin(product), mensShoes = isMensMoccasin(product) || isDerby(product), mappedShoes = womensShoes || mensShoes, mensTee = isMensTee(product);
    const fitPrefix = womensShoes ? 'women_' : 'men_';
    const usLabel = fitStrings[fitPrefix+'us'];
    const mappedUS = eu => displayUS(product,eu);  
    subtitle.textContent = footwear ? (state.intent === 'pay' ? shoeStrings.choose_pay : mappedShoes ? fitStrings[fitPrefix+'choose'] : shoeStrings.choose) : strings.choose;
    let shoeIndex = -1;
    product.options.forEach((option,index) => {
      const values=option.values || [...new Set(product.variants.map(variant=>variant.options[index]))];
      const field=document.createElement('fieldset'), legend=document.createElement('legend'), group=document.createElement('div');
      const optionLabel=option.name || option;
      const shoe = footwear && ['size','taille','shoe size','pointure'].includes(String(optionLabel).trim().toLowerCase());
      if (shoe) shoeIndex = index;
      if (values.length === 1 && !shoe) { state.values[index]=values[0]; return; }
      const hasUS = shoe && values.some(value=>mappedUS(value));
      legend.textContent=shoe ? (hasUS ? (mappedShoes ? fitStrings[fitPrefix+'shoes'] : 'US | EU') : shoeStrings.eu_label) : ['shoe size','pointure'].includes(String(optionLabel).toLowerCase()) ? 'EU · '+optionLabel : (mensTee ? fitStrings.tee_label : optionLabel);
      group.className='tpl-purchase-dialog__values'; field.append(legend);
      if (shoe) {
        field.className='tpl-purchase-dialog__shoe-field'; group.classList.add('tpl-purchase-dialog__size-rail');
        if (hasUS) group.classList.add('tpl-purchase-dialog__size-rail--paired');
        enhanceSizeRail(group);
      }
      field.append(group);
      values.forEach(value=>{
        const button=document.createElement('button'); button.type='button'; button.textContent=value;
        if (hasUS) {
          const eu=document.createElement('span');eu.textContent='EU '+value;
          const divider=document.createElement('span');divider.textContent='|';divider.className='tpl-purchase-dialog__size-divider';divider.setAttribute('aria-hidden','true');
          const us=document.createElement('span');us.textContent=usLabel+' '+(mappedUS(value)||'—');
          button.replaceChildren(us,divider,eu);
        }
        if (shoe) { button.dataset.shoeValue=value; button.setAttribute('aria-label',(mappedUS(value)?usLabel+' '+mappedUS(value)+' | ':'')+'EU '+value); }
        const matching=product.variants.filter(variant=>variant.options[index]===value && state.values.every((selected,i)=>i===index || !selected || variant.options[i]===selected));
        const available=matching.some(variant=>variant.available);
        if(matching.length&&matching.every(isPreorder)){const note=document.createElement('small');note.textContent=strings.preorder;button.append(note);}
        button.disabled=!available && !(shoe && matching.length>0);button.dataset.unavailable=String(!available && matching.length>0); button.setAttribute('aria-pressed',String(state.values[index]===value));
        if(shoe && !available && matching.length>0)button.setAttribute('aria-label',button.getAttribute('aria-label')+' · '+notificationStrings.short_label);
        if (!available) { const note=document.createElement('small');note.textContent=strings.unavailable;button.append(note); }
        button.addEventListener('click',()=>{
          if(busy)return; state.values[index]=value;
          const variant=product.variants.find(item=>item.options.every((v,i)=>v===state.values[i]));
          if(variant)selectVariant(variant);else {renderOptions(); const next=[...options.querySelectorAll('fieldset')].find(el=>!el.querySelector('[aria-pressed=true]'));next?.querySelector('button:not(:disabled)')?.focus();}
        }); group.append(button);
      }); options.append(field);
    });
    if (footwear && shoeIndex >= 0) {
      state.variant = product.variants.find(variant => variant.options.every((value,index) => value === state.values[index])) || null;
      const confirmation=document.createElement('p'); confirmation.className='tpl-purchase-dialog__chosen-size'; confirmation.setAttribute('role','status');
      const eu=state.values[shoeIndex];
      confirmation.textContent=eu ? (mappedShoes ? fitStrings[fitPrefix+'selected'] : shoeStrings.selected)+' · '+(mappedUS(eu)?usLabel+' '+mappedUS(eu)+' | ':'')+'EU '+eu : mappedShoes ? fitStrings[fitPrefix+'missing'] : shoeStrings.missing;
      const note=document.createElement('p'); note.className='tpl-purchase-dialog__size-note'; note.textContent=mappedShoes ? fitStrings[fitPrefix+'indicative'] : shoeReference.verified ? shoeStrings.verified : shoeStrings.indicative;
      const action=document.createElement('button'); action.type='button'; action.className='tpl-purchase-dialog__size-submit'; action.dataset.shoeConfirm=''; action.textContent=state.variant && !state.variant.available ? notificationStrings.short_label : (state.intent==='pay' ? shoeStrings.pay : shoeStrings.add)+' · '+money(state.variant?.price ?? product.price); action.disabled=!state.variant;
      action.addEventListener('click',()=>{if(busy||!state.variant)return;if(!state.variant.available){showAvailability(state.variant);return;}if(state.intent==='pay')showTerms();else add();});
      options.append(confirmation);
      if (mappedShoes) options.append(note);
      options.append(action);
      if (state.sale.guideHtml) {
        const help=document.createElement('template'); help.innerHTML=state.sale.guideHtml;
        options.append(help.content.cloneNode(true));
      } else if (moccasin) options.append(dialog.querySelector(womensShoes ? '[data-tpl-women-shoe-help]' : '[data-tpl-shoe-help]').content.cloneNode(true));
      options.querySelectorAll('details').forEach(el=>{el.open=openHelp.includes(el.querySelector('summary')?.textContent);});
      const selected=options.querySelector('[data-shoe-value][aria-pressed=true]');
      if(selected)selected.scrollIntoView({block:'nearest',inline:'nearest'});
      return;
    }
    const exact=product.variants.find(variant=>variant.options.every((value,index)=>value===state.values[index]));
    if (!state.main) {
      state.variant = exact || null;
      if (exact) subtitle.textContent = money(exact.price);
      const action = document.createElement('button');
      action.type = 'button'; action.className = 'tpl-purchase-dialog__size-submit';
      action.dataset.quickConfirm = '';
      action.textContent = (exact && isPreorder(exact) ? strings.preorder + ' · ' : '') + shoeStrings.add + ' · ' + money(exact?.price ?? product.price);
      action.disabled = !exact?.available;
      action.addEventListener('click', () => { if (!busy && state.variant?.available) add(); });
      if (mensTee) {
        const fitNote=document.createElement('p'); fitNote.className='tpl-purchase-dialog__size-note'; fitNote.textContent=fitStrings.tee_note; options.append(fitNote);
      }
      options.append(action);
      if (mensTee) {
        options.append(dialog.querySelector('[data-tpl-tee-help]').content.cloneNode(true));
        options.querySelectorAll('details').forEach(el=>{el.open=openHelp.includes(el.querySelector('summary')?.textContent);});
      }
      return;
    }
    if(exact && !options.children.length) selectVariant(exact);
  };
  const begin = async (url, intent, trigger, main, sizeVariant) => {
    if (busy) return;
    document.dispatchEvent(new CustomEvent('proper:commerce',{detail:{event:'quick_add_open'}}));
    opener=trigger; handingToCart=false; state=null; const current=++token;reset(); heading.textContent=strings.loading;subtitle.textContent='';show();setBusy(true);
    try {
      const parsed=new URL(url,location.origin);if(parsed.origin!==location.origin)throw new Error(strings.error);
      productLink.href=parsed.pathname;
      let product;
      let sale;
      // The current page already has the product, prices and purchase details.
      // Keep opening Add / Pay independent of preview-only template requests.
      const embedded=main ? (trigger.closest('[data-tpl-purchase-bar]') || document.querySelector('[data-tpl-purchase-bar]'))?.querySelector('[data-tpl-purchase-data]') : null;
      if (embedded) {
        ({product,sale}=JSON.parse(embedded.textContent));
      } else {
        const availabilityUrl=new URL(parsed);
        availabilityUrl.searchParams.set('view','tpl-availability');
        const previewTheme=new URL(location.href).searchParams.get('preview_theme_id');
        if (previewTheme) availabilityUrl.searchParams.set('preview_theme_id',previewTheme);
        [product,sale]=await Promise.all([
          request(parsed.pathname.replace(/\/$/,'')+'.js'),
          request(availabilityUrl.pathname+availabilityUrl.search, {headers:{'Accept':'text/html'}})
        ]);
      }
      if(current!==token || !dialog.open)return;
      if(!product?.variants?.length || !Array.isArray(product.options) || !sale?.variants)throw new Error(strings.error);
      if(product.requires_selling_plan || product.selling_plan_groups?.length || (!main && product.options.length>1)){window.location.assign(parsed.pathname);return;}
      if (!main) product = {...product, variants:product.variants.map(variant => ({...variant, available:variant.available && sale.variants[String(variant.id)]?.quickAvailable !== false}))};
      state={product,sale,intent,main,values:[],variant:null,unit:'EU'};
      product.options.forEach((option,index)=>{ if(option.values?.length===1)state.values[index]=option.values[0];else state.values[index]=null; });
      setBusy(false);
      const requestedVariant=sizeVariant || (main ? new URLSearchParams(location.search).get('variant') : parsed.searchParams.get('variant'));
      const remembered=requestedVariant || chosen.get(product.id);
      const variant=product.variants.find(item=>String(item.id)===String(remembered) && (item.available || isFootwear(product)));
      if(isFootwear(product) && variant){state.variant=variant;state.values=[...variant.options];if(!variant.available)showAvailability(variant);else if(sizeVariant)selectVariant(variant);else renderOptions();}
      else if(variant && !main && requestedVariant){state.values=[...variant.options];selectVariant(variant);}
      else if(intent==='pay' && variant){state.variant=variant;updateBar(variant);showTerms();}else renderOptions();
    }catch(cause){
      if(current!==token || !dialog.open)return;
      heading.textContent=strings.selection;subtitle.textContent='';options.hidden=true;
      dialog.querySelector('.tpl-purchase-dialog__tax').hidden=true;
      error.textContent=cause.message || strings.error;productLink.hidden=false;setBusy(false);
    }
  };
  document.addEventListener('click',event=>{
    const quick=event.target.closest('[data-tpl-quick-shop]');
    const action=event.target.closest('[data-tpl-purchase-add],[data-tpl-purchase-pay]');
    const sizeChoice=event.target.closest('[data-tpl-select-size]');
    if(sizeChoice){const bar=document.querySelector('[data-tpl-purchase-bar]');if(bar){event.preventDefault();begin(bar.dataset.productUrl,'add',sizeChoice,true,sizeChoice.dataset.tplSelectSize);}}
    if(quick){if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;event.preventDefault();begin(quick.dataset.tplQuickShop,'add',quick,false);}
    if(action){const bar=action.closest('[data-tpl-purchase-bar]');if(bar)begin(bar.dataset.productUrl,action.hasAttribute('data-tpl-purchase-pay')?'pay':'add',action,true);}
    if(event.target.closest('[data-tpl-purchase-close]') && (!busy || !state))dialog.close();
  });
  dialog.addEventListener('cancel',event=>{if(busy && state)event.preventDefault();});
  dialog.addEventListener('close',()=>{++token; if(!state)setBusy(false); if(!busy){state=null;notificationForm.reset();} if(!handingToCart)opener?.focus({preventScroll:true});});
  document.addEventListener('theme:cart:open',()=>{
    if(dialog.open && !success.hidden){handingToCart=true;dialog.close();}
  });
  dialog.querySelector('[data-tpl-purchase-back]').addEventListener('click',()=>{if(busy)return;terms.hidden=true;options.hidden=false;if(state.product.options.every(option=>option.values?.length===1)){dialog.close();return;}state.variant=null;state.values=state.product.options.map(option=>option.values?.length===1?option.values[0]:null);renderOptions();if(!options.children.length)dialog.close();});
  dialog.querySelector('[data-tpl-purchase-accept]').addEventListener('click',()=>add(true));
  notification.querySelector('[data-tpl-notification-back]').addEventListener('click',()=>{
    if(busy)return;
    notification.hidden=true;notificationForm.reset();state.notificationVariant=null;state.variant=null;
    state.values=state.product.options.map(()=>null);options.hidden=false;error.textContent='';
    dialog.querySelector('.tpl-purchase-dialog__tax').hidden=false;renderOptions();
    options.querySelector('[data-shoe-value]')?.focus({preventScroll:true});
  });
  notificationForm.addEventListener('submit',async event=>{
    event.preventDefault();
    if(busy || !dialog.open || notification.hidden || notificationRequest.hidden || !state?.notificationVariant || state.notificationVariant.available || !notificationForm.reportValidity())return;
    const variantId=state.notificationVariant.id;
    const email=notificationEmail.value.trim();
    setBusy(true);error.textContent='';notificationEmail.disabled=true;
    const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),15000);
    try{
      const response=await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id='+encodeURIComponent(notification.dataset.companyId),{
        method:'POST',credentials:'omit',signal:controller.signal,
        headers:{'Content-Type':'application/vnd.api+json','Accept':'application/vnd.api+json','revision':'2026-07-15'},
        body:JSON.stringify({
          data:{
            type:'back-in-stock-subscription',
            attributes:{
              profile:{data:{type:'profile',attributes:{email}}},
              channels:['EMAIL']
            },
            relationships:{
              variant:{data:{type:'catalog-variant',id:'$shopify:::$default:::'+variantId}}
            }
          }
        })
      });
      if(response.status!==202)throw new Error(response.status===429 ? notificationStrings.rate_limit : notificationStrings.error);
      notificationForm.reset();notificationRequest.hidden=true;notificationSuccess.hidden=false;notificationSuccess.focus({preventScroll:true});
    }catch(cause){error.textContent=cause.name==='AbortError' || cause instanceof TypeError ? notificationStrings.error : cause.message || notificationStrings.error;}
    finally{clearTimeout(timeout);notificationEmail.disabled=false;setBusy(false);}
  });

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpl-search-page"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => document.querySelectorAll('[data-tpl-search-page]').forEach(section => {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const dialog = section.querySelector('.tpl-search-filters');
    const trigger = section.querySelector('[data-tpl-search-refine]');
    if (!dialog || !trigger) return;
    let overflow = '';
    trigger.addEventListener('click', () => {
      overflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
    });
    section.querySelector('[data-tpl-search-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      const rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
    });
    dialog.addEventListener('close', () => { document.body.style.overflow = overflow; trigger.focus({preventScroll:true}); });
  });
  init();
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpl-selection-design"] && !Shopify.designMode) return;
  try {
    (() => {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;
  let previousFocus;
  let pendingVariant;
  let addedVariant;
  const resetAdded = () => {
    addedVariant = null;
    pendingVariant = null;
    drawer.removeAttribute('data-tpl-selection-added');
    const heading = drawer.querySelector('[data-selection-heading]');
    if (heading) heading.textContent = drawer.dataset.selectionTitle;
  };
  const syncCount = () => {
    const holder = drawer.querySelector('[data-items-holder]');
    if (!holder) return;
    const count = [...holder.querySelectorAll('[data-quantity-field]')].reduce((total, input) => total + (Number(input.value) || 0), 0);
    document.querySelectorAll('[data-tpl-sticky-count],[data-tpl-selection-count]').forEach(node => {
      if (node.textContent !== String(count)) node.textContent = String(count);
    });
    const items = [...holder.querySelectorAll('[data-cart-item]')];
    items.forEach(item => {
      const bottom = item.querySelector('.cart__item__bottom');
      if (bottom && !bottom.querySelector('.tpl-selection-quantity-label')) {
        const label = document.createElement('span');
        label.className = 'tpl-selection-quantity-label';
        label.textContent = drawer.dataset.selectionQuantityLabel;
        bottom.prepend(label);
      }
      item.toggleAttribute('data-tpl-added-item', !!addedVariant && item.getAttribute('data-item')?.split(':')[0] === addedVariant);
    });
    if (addedVariant && !items.some(item => item.hasAttribute('data-tpl-added-item'))) resetAdded();
  };
  const recordAdd = form => {
    if (!form) return;
    const variant = form.querySelector('[name="id"]')?.value;
    if (variant) pendingVariant = { id: String(variant), time: Date.now() };
  };
  document.addEventListener('submit', event => {
    if (event.target.closest('product-form')) recordAdd(event.target);
  }, true);
  document.addEventListener('click', event => {
    const addButton = event.target.closest('[data-add-to-cart]');
    if (addButton && !addButton.disabled) recordAdd(addButton.closest('form') || addButton.closest('product-form')?.querySelector('form'));
    if (event.target.closest('[data-cart-drawer-toggle]') && !drawer.contains(event.target)) resetAdded();
  }, true);
  new MutationObserver(syncCount).observe(drawer, { childList: true, subtree: true });
  document.addEventListener('theme:cart:open', () => { previousFocus = document.activeElement; });
  document.addEventListener('theme:cart:close', () => {
    window.setTimeout(() => {
      if (previousFocus?.isConnected && !drawer.contains(previousFocus)) previousFocus.focus({ preventScroll: true });
    }, 400);
  });
  document.addEventListener('theme:cart:added', () => {
    if (pendingVariant && Date.now() - pendingVariant.time < 30000) {
      addedVariant = pendingVariant.id;
      pendingVariant = null;
      drawer.setAttribute('data-tpl-selection-added', '');
      const heading = drawer.querySelector('[data-selection-heading]');
      if (heading) heading.textContent = drawer.dataset.selectionAddedTitle;
    }
    syncCount();
  });
  document.addEventListener('theme:cart:error', () => { pendingVariant = null; });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
      event.preventDefault();
      drawer.querySelector('.cart-drawer__close')?.click();
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpl-sfa-inline-film"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-sfa-inline] video').forEach(video=>video.addEventListener('play',()=>document.querySelectorAll('[data-sfa-inline] video').forEach(other=>{if(other!==video)other.pause()})));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpl-size-guide-maison"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tpl-size-maison')) {
  customElements.define('tpl-size-maison', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.gender = 'men';
      this.chart = 'tailored';
      this.family = 'footwear';
      const tabs = [...this.querySelectorAll('[data-sg-family]')];
      this.showFamily = (family, focus = false) => {
        this.family = family;
        tabs.forEach(tab => {
          const active = tab.dataset.sgFamily === family;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus();
          this.querySelector('#' + tab.getAttribute('aria-controls')).hidden = !active;
        });
      };
      this.showGender = gender => {
        this.gender = gender;
        this.querySelectorAll('[data-sg-gender]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.sgGender === gender)));
        this.querySelectorAll('[data-sg-audience]').forEach(panel => panel.hidden = panel.dataset.sgAudience !== gender);
        this.updateUnits();
      };
      this.updateUnits = () => {
        this.querySelector('.sg-units').hidden = this.gender === 'men' ? this.chart === 'tailored' : this.chart === 'bottoms';
      };
      this.showPiece = (key, focus = false) => {
        const selected = this.querySelector('[data-sg-piece="' + key + '"]');
        if (!selected) return;
        this.chart = selected.dataset.sgChart;
        this.querySelectorAll('[data-sg-piece]').forEach(button => button.setAttribute('aria-pressed', String(button === selected)));
        this.querySelectorAll('[data-sg-piece-copy]').forEach(copy => copy.hidden = copy.dataset.sgPieceCopy !== key);
        this.querySelectorAll('[data-sg-chart-panel]').forEach(panel => panel.hidden = panel.dataset.sgChartPanel !== this.chart);
        this.querySelector('[data-sg-women-tops]').hidden = this.chart === 'bottoms';
        this.querySelector('[data-sg-women-bottoms]').hidden = this.chart !== 'bottoms';
        this.updateUnits();
        if (focus) {
          const detail = this.querySelector('#SgClothingDetail');
          detail.focus({preventScroll:true});
          detail.scrollIntoView({block:'start',behavior:'instant'});
        }
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.showFamily(tab.dataset.sgFamily));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) {event.preventDefault();this.showFamily(tabs[next].dataset.sgFamily, true);}
        });
      });
      this.querySelectorAll('[data-sg-gender]').forEach(button => button.addEventListener('click', () => this.showGender(button.dataset.sgGender)));
      this.querySelectorAll('[data-sg-piece]').forEach(button => button.addEventListener('click', () => this.showPiece(button.dataset.sgPiece, true)));
      this.querySelectorAll('[data-sg-unit]').forEach(button => button.addEventListener('click', () => {
        const unit = button.dataset.sgUnit;
        this.querySelectorAll('[data-sg-unit]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        this.querySelectorAll('[data-sg-cm]').forEach(cell => cell.textContent = unit === 'cm' ? cell.dataset.sgCm : cell.dataset.sgCm.split('–').map(value => (Number(value) / 2.54).toFixed(1)).join('–'));
        this.querySelectorAll('[data-sg-unit-label]').forEach(label => label.textContent = '(' + button.textContent.trim() + ')');
      }));
      const revealHash = () => {
        const hash = decodeURIComponent(location.hash.slice(1)).toLowerCase();
        if (!hash) return;
        if (hash.includes('women')) this.showGender('women');
        else if (hash.includes('men')) this.showGender('men');
        if (/foot|sizemen$|sizewomen$/.test(hash)) this.showFamily('footwear');
        const map = {tailoring:'single',blazer:'single',double:'double',knitwear:'knit',tees:'tee',shirt:'shirt',trouser:'trousers',overcoat:'overcoat',outerwear:'leather',hoodie:'hoodie',jog:'joggers'};
        for (const [old, key] of Object.entries(map)) if (hash.includes(old)) {this.showFamily('clothing');this.showPiece(key);break;}
        if (/headwear|beanie|one.size|accessor/.test(hash)) this.showFamily('one_size');
        if (hash.includes('kid')) this.querySelector('#SizeKids details').open = true;
      };
      this.querySelector('[data-sg-back]').addEventListener('click', () => {const selected = this.querySelector('[data-sg-piece][aria-pressed="true"]'); selected.focus({preventScroll:true}); this.querySelector('#SgPieces').scrollIntoView({block:'start',behavior:'instant'});});
      this.hashListener = revealHash;
      window.addEventListener('hashchange', revealHash);
      this.updateUnits();
      revealHash();
    }
    disconnectedCallback() { window.removeEventListener('hashchange', this.hashListener); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpl-starball-note"] && !Shopify.designMode) return;
  try {
    (() => {
  const notes = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let frame = 0;
  const position = (note, state) => {
    const rect = note.getBoundingClientRect();
    const start = innerHeight * .85;
    const finish = Math.min(160, innerHeight * .25);
    const progress = reduced.matches ? .5 : Math.max(0, Math.min(1, (start - rect.top) / Math.max(1, start - finish)));
    const x = 32 + progress * 134;
    const y = reduced.matches ? 37 : 37 - 3 * Math.sin(Math.PI * progress);
    const angle = reduced.matches ? 0 : -8 + progress * 16;
    state.ball.setAttribute('transform', `translate(${x.toFixed(2)} ${y.toFixed(2)}) rotate(${angle.toFixed(2)} 11 11)`);
  };
  const update = () => {
    frame = 0;
    notes.forEach((state, note) => {
      if (!note.isConnected) { observer?.unobserve(note); notes.delete(note); return; }
      if (state.visible || reduced.matches) position(note, state);
    });
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => { const state = notes.get(entry.target); if (state) state.visible = entry.isIntersecting; });
    schedule();
  }) : null;
  const init = () => document.querySelectorAll('[data-tpl-starball-note]').forEach(note => {
    if (notes.has(note)) return;
    const ball = note.querySelector('[data-tpl-starball-ball]');
    if (!ball) return;
    const state = { ball, visible: !observer };
    notes.set(note, state);
    position(note, state);
    observer?.observe(note);
  });
  addEventListener('scroll', schedule, { passive: true });
  addEventListener('resize', schedule, { passive: true });
  reduced.addEventListener('change', () => { notes.forEach((state, note) => position(note, state)); });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', schedule);
  document.addEventListener('DOMContentLoaded', init, { once: true });
  init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpl-tee-share"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = () => document.querySelectorAll('[data-tpl-piece-share]').forEach(root => {
    if (root.dataset.ready) return;
    const summary = root.querySelector('summary');
    const copy = root.querySelector('[data-tpl-share-copy]');
    const email = root.querySelector('[data-tpl-share-email]');
    const status = root.querySelector('[data-tpl-share-status]');
    const manual = root.querySelector('[data-tpl-share-manual]');
    const input = manual.querySelector('input');
    const variants = JSON.parse(root.dataset.variants).map(String);
    root.dataset.ready = 'true'; copy.hidden = false;
    const shareUrl = () => {
      const url = new URL(root.dataset.url, location.origin);
      url.search = ''; url.hash = '';
      const current = new URL(location.href);
      const variant = current.searchParams.get('variant');
      if (variants.includes(variant)) url.searchParams.set('variant', variant);
      const preview = current.searchParams.get('preview_theme_id');
      if (preview && preview === root.dataset.themeId) url.searchParams.set('preview_theme_id', preview);
      return url.href;
    };
    const updateLinks = () => {
      const url = shareUrl(); input.value = url;
      email.href = 'mailto:?subject=' + encodeURIComponent(root.dataset.title) + '&body=' + encodeURIComponent(root.dataset.message + '\n\n' + url);
      return url;
    };
    updateLinks();
    let sharing = false;
    summary.addEventListener('click', async event => {
      updateLinks(); status.textContent = ''; manual.hidden = true;
      if (!navigator.share || root.open) return;
      event.preventDefault();
      if (sharing) return;
      sharing = true;
      try { await navigator.share({ title: root.dataset.title, text: root.dataset.message, url: shareUrl() }); }
      catch (cause) { if (cause.name !== 'AbortError') root.open = true; }
      finally { sharing = false; }
    });
    copy.addEventListener('click', async () => {
      const url = updateLinks(); status.textContent = '';
      try {
        if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
        await navigator.clipboard.writeText(url);
        manual.hidden = true; status.textContent = root.dataset.copied;
      } catch {
        manual.hidden = false; input.focus(); input.select(); status.textContent = root.dataset.manual;
      }
    });
    email.addEventListener('click', updateLinks);
    root.addEventListener('keydown', event => { if (event.key === 'Escape' && root.open) { root.open = false; summary.focus(); } });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('tpl:product:changed', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpl-view-all-directory"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown',event=>{
    if(event.key!=='Escape')return;
    const directory=event.target.closest('[data-va-directory][open]');
    if(!directory)return;
    directory.open=false;
    directory.querySelector('summary').focus({preventScroll:true});
  });
  } catch(e) { console.error(e); }
})();

})();
